import PostAttachmentView from './PostAttachmentView'

export default PostAttachmentView
